import {
  Button,
  Card,
  Col,
  Flex,
  Row,
  Space,
  Table,
  Tag,
  Spin,
  Avatar,
  Typography
} from "antd";
import React, { useState } from "react";
import Title from "antd/es/typography/Title";
import { useEffect } from "react";
import { DeleteIcon, EditIcon } from "../../../../../../assets/svg";
import { colors } from "../../../../../../constants/colors";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { routes } from "../../../../../../constants";
import {
  baseRouteMaker,
  baseRouteMakerForSuperAdmin,
} from "../../../../../../constants/routeConsts";
import Actions from "../../../../../../redux/actions";
import { dateObjToDispViewDate,timeObjToDispViewTimeWithSuffix, getColorBasedOnStatus } from "../../../../../../utils/utils";
import { getPackagesAction } from "../../../../../../redux/services/packages/packagesServices";
import Spinner from "../../../../../common/spinner/Spinner";
import { useCallback } from "react";
import { getOrganizationTopListingSubscriptionPlanAction } from "../../../../../../redux/services/organization-sponsorship/organizationSponsorshipServices";
import useDebounce from "../../../../../../hooks/useDebounce";
import { appConstConfig } from "../../../../../../constants/config/appConstConfig";
import styles from "./OrganizationSponsorship.module.scss";
import { StatusTag } from "../../../../../common/status-tag";
import { UnorderedListOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.guess();
const OrganizationSponsorshipList = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  /* loading dependencies */

  /* table dependencies */
  const [columns, setColumns] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const { organizationSponsorships } = useSelector(
    (state) => state.organizationSponsorships
  );
  const { debouncedValue: debouncedSearchValue, debounceLoading } = useDebounce(
    searchValue,
    500
  );
  const [pagination, setPagination] = useState({
    pageNo: appConstConfig.DEFAULT_TABLE_PAGE_NUMBER,
    pageSize: appConstConfig.DEFAULT_TABLE_PAGE_SIZE,
  });
  const paginationObj = {
    total: organizationSponsorships?.total,
    current: pagination?.pageNo,
    pageSize: pagination?.pageSize,
    onChange: (pageNo, pageSize) => setPagination({ pageNo, pageSize }),
    pageSizeOptions: appConstConfig.DEFAULT_PAGE_SIZE_OPTIONS_ARR,
    showSizeChanger: true
  };
  /* table dependencies */

  /* dialog dependencies */
  const [openServiceDeleteDialog, setOpenServiceDeleteDialog] = useState(false);
  /* dialog dependencies */

  useEffect(() => {
    handleGetTableData();
  }, [pagination, debouncedSearchValue]);

  /* function definition to get table data */
  const handleGetTableData = () => {
    const dataToBeSent = {
      page: debouncedSearchValue !== "" ? 1 : pagination?.pageNo,
      limit: pagination?.pageSize,
      search: debouncedSearchValue
    };
    dispatch(
      getOrganizationTopListingSubscriptionPlanAction(dataToBeSent, setLoading)
    );
  };
  /* function definition to get table data */

  /* initial dependencies rendering */
  useEffect(() => {
    /* table column config */
    const tempTableColumns = [
      {
        title: t("Modules.Ads.name"),
        dataIndex: "name",
        key: "name",
      },
      {
        title: t("Modules.addOns.duration"),
        dataIndex: "duration",
        key: "duration",
        render: (_, record) => (
          <p>{`${record?.duration} ${record?.duration_unit}`}</p>
        ),
      },
      {
        title: t("servicesList.price"),
        dataIndex: "price",
        key: "price",
        render: (_, record) => <p>{`${record?.price} ${record?.currency?.toUpperCase()}`}</p>,
      },
      {
        title: t("Modules.AutoCredit.status"),
        key: "is_active",
        dataIndex: "is_active",
        render: (_, record) => {
          return (
            <>
              <StatusTag status={record?.is_active}/>
            </>
          );
        },
      },
      {
        title: t("createAt"),
        dataIndex: "created_at",
        key: "created_at",
        render: (_, record) => (
          <p>{`${dateObjToDispViewDate(record?.created_at, "ddmmyyyy")} - ${timeObjToDispViewTimeWithSuffix(dayjs
              .utc(record?.created_at).local().tz(dayjs.tz.guess()).format("YYYY-MM-DDTHH:mm:ss")
          )}`}</p>
        ),
      },
      {
        title: t("servicesList.action"),
        key: "action",
        align: "center",
        render: (_, record) => {
          return (
            <>
              <Button
                type="text"
                size="medium"
                icon={<EditIcon fillColor={colors.slateGray} />}
                onClick={(e) => handleAddEditDetails(e, record)}
              />
            </>
          );
        },
      },
    ];
    /* table column config */
    setColumns(tempTableColumns);
  }, []);
  /* initial dependencies rendering */

  const handleAddEditDetails = (e, row) => {
    dispatch(
      Actions.createAction(Actions.SELECTED_ORGANIZATION_SPONSORSHIP_ID, {
        selectedOrganizationSponsorshipId: "",
      })
    );
    navigate(baseRouteMakerForSuperAdmin(routes.ADD_ORGANIZATION_SPONSORSHIP));
    if (
      row?._id &&
      row?._id !== "" &&
      row?._id !== null &&
      row?._id !== undefined
    ) {
      const selectedOrganizationSponsorshipId = row?._id;
      dispatch(
        Actions.createAction(Actions.SELECTED_ORGANIZATION_SPONSORSHIP_ID, {
          selectedOrganizationSponsorshipId,
        })
      );
    }
  };

  return (
    <div className={styles.packageListContainer}>
      <Flex vertical gap="2rem">
        <Flex align="center" justify="space-between">
          <Card
                  bordered
                  hoverable
                  style={{
                    width: 300,
                    padding: 0,
                    borderRadius: 20,
                    border: `1px solid ${colors.oceanBlue}`,
                  }}
                >
              <Row gutter={[24, 24]} align="middle" justify="center">
                <Col span={6}>
                  <Button
                    type="primary"
                    shape="circle"
                    size="middle"
                    icon={<UnorderedListOutlined  style={{ fontSize: 22 }} />}
                    style={{ background: colors.oceanBlue }}
                  />
                </Col>
                <Col span={18}>
                  <Flex vertical>
                    <Typography.Title level={3}>
                      {t("orgPlans")}
                    </Typography.Title>
                    <Typography.Title
                      level={2}
                      style={{ margin: 0, color: colors.DarkMint }}
                    >
                      {`${organizationSponsorships?.total || 0}`}
                    </Typography.Title>
                  </Flex>
                </Col>
              </Row>
            </Card>
          <Button type="primary" onClick={(e) => handleAddEditDetails(e, null)}>
            {t("Modules.Ads.addOrganizationTopListingPlan")}
          </Button>
        </Flex>
        {loading ? (
          <Spinner />
        ) : (
          <Table
            dataSource={organizationSponsorships?.data}
            columns={columns}
            pagination={paginationObj}
          />
        )}
      </Flex>
    </div>
  );
};

export default OrganizationSponsorshipList;
